import { TemplateConfig } from '../types';

export const compoundCrossConfig: TemplateConfig = {
  id: 'compound-cross',
  name: '复合十字架',
  description: '复合十字架塔罗牌阵分析',
  cardCount: 5,
  
  fieldDefaults: {
    title: '能不能和前任复合',
    customerQuestion: '**我和他还能不能复合，他想不想复合**。请较为明确地回答"能否复合"的问题，不要给出太模棱两可的答案。',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 3 行第 1 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 3 张牌',
      '请输入第 2 行第 2 张牌'
    ],
    cardInfos: [
      '你们会不会复合',
      '你们之间的阻碍',
      '对方想不想复合',
      '对方对你的想法和感觉',
      '建议牌'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#722ed1',
    backgroundColor: '#f9f0ff',
    icon: '✚'
  }
};